import { FormFieldTypes } from "../../../../data/formFieldType";

export const OtherInformationData = {
  name: "OtherInformationData",
  initialState: {
    howDidYouLearnSGBCId: null,
    OtherInformationAboutSGBC: "",
    otherInformationProvidedtoSGBC: "",
    reasonOfJoining: null,
    OtherReasonOfJoining: "",
  },
  formFields: [
    {
      id: "howDidYouLearnSGBCId",
      lable: "How did you learn about SGBC",
      Field_Name: "How did you learn about SGBC",
      fieldType: FormFieldTypes.SELECT,
      dataField: "howDidYouLearnSGBCId",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isMultiSelect: true,
      },
      validation: [{ type: "require" }],   
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2 mb-3",
      },
    },
    {
      id: "OtherInformationAboutSGBC",
      lable: "Others; please specify",
      Field_Name: "Others; please specify",
      fieldType: FormFieldTypes.INPUT,
      dataField: "OtherInformationAboutSGBC",
      fieldSetting: {
        placeholder: "",
      },
      validation: [],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2 mb-3 d-none",
      },
    },
    {
      id: "otherInformationProvidedtoSGBC",
      lable: "Do you wish to provide any other information to SGBC?",
      Field_Name: "Do you wish to provide any other information to SGBC?",
      fieldType: FormFieldTypes.TEXTAREA,
      dataField: "otherInformationProvidedtoSGBC",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        maxWords: 200
      },
      validation: [],
      style: {
        containerCss: "col-md-12 mb-3",
      },
    },
    {
      id: "reasonOfJoining",
      lable: "Reasons for joining SGBC Corporate Membership",
      Field_Name: "Reasons for joining SGBC Corporate Membership",
      fieldType: FormFieldTypes.SELECT,
      dataField: "reasonOfJoining",
      fieldSetting: {
        placeholder: "",
        options: [],
        isMultiSelect: true,
      },
      validation: [{ type: "require" }],      
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2",
      },
    },
      {
      id: "OtherReasonOfJoining",
       lable: "Recommended By / Others; please specify",
      Field_Name: "Recommended By / Others; please specify",
      fieldType: FormFieldTypes.INPUT,
      dataField: "OtherReasonOfJoining",
      fieldSetting: {
        placeholder: "",
      },
      validation: [],      
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2 d-none",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};